module.exports = __webpack_public_path__ + "img/StationaryEngine.e183ee52.png";